import Popover from "@components/ui/popover";
import { cn } from "@lib/cn";
import { IconDots, IconEye, IconTrash } from "@tabler/icons-react";
import { useState } from "react";

export const SessionRowActions = ({
  onSessionDetails,
  onDeleteSession,
}: {
  onSessionDetails: () => void;
  onDeleteSession: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen} placement="bottom-end">
      <Popover.Trigger
        className={cn(
          "tw-size-8 tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-rounded-md tw-transition-colors hover:tw-bg-blue-50",
          isOpen && "tw-bg-blue-50",
        )}
      >
        <IconDots className="tw-size-4 tw-text-blue-500" />
      </Popover.Trigger>
      <Popover.Content className="tw-w-48 tw-z-[10000] tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-shadow-md tw-p-1">
        <button
          type="button"
          onClick={() => {
            onSessionDetails();
            setIsOpen(false);
          }}
          className="tw-flex tw-h-9 tw-w-full tw-items-center tw-gap-2 tw-rounded tw-px-3 tw-font-sans tw-text-sm tw-text-blue tw-transition-colors hover:tw-bg-blue-50"
        >
          <IconEye className="tw-size-4" />
          Session details
        </button>
        <button
          type="button"
          onClick={() => {
            onDeleteSession();
            setIsOpen(false);
          }}
          className="tw-flex tw-h-9 tw-w-full tw-items-center tw-gap-2 tw-rounded tw-px-3 tw-font-sans tw-text-sm tw-text-blue tw-transition-colors hover:tw-bg-blue-50"
        >
          <IconTrash />
          Delete session
        </button>
      </Popover.Content>
    </Popover>
  );
};
